module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isExpanded) ? _c('div', {
    ref: "appDrawer",
    staticClass: "sidebar-view",
    attrs: {
      "md-active": _vm.visible
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.commonActions && _vm.commonActions.length) ? _c('div', {
    staticClass: "common-actions"
  }, _vm._l((_vm.commonActions), function(action) {
    return _c('md-button', {
      key: action.key,
      nativeOn: {
        "click": function($event) {
          _vm.onCommonAction(action.key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(action.name) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('md-list', _vm._l((_vm.list), function(item) {
    return _c('md-list-item', {
      key: item[_vm.itemKeyField]
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((_vm.itemActions), function(action) {
      return _c('md-button', {
        key: action.key,
        staticClass: "md-icon-button md-list-action",
        nativeOn: {
          "click": function($event) {
            _vm.onItemAction(action.key, item)
          }
        }
      }, [_c('md-icon', [_vm._v("\n          " + _vm._s(action.icon) + "\n        ")]), _vm._v(" "), (action.name) ? _c('md-tooltip', [_vm._v("\n          " + _vm._s(action.name) + "\n        ")]) : _vm._e()], 1)
    })], 2)
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d72e762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarView.vue
// module id = 1019
// module chunks = 1